$(window).on("load", function () {
  //================================
  // // ページ読み込み時のselectボックスの選択をhiddenしてるメール送信欄,確認画面欄に出力
  // //================================
  // const entryNameSelectedTxt = $(
  //   "#entry_name option[selected='selected']"
  // ).text();
  // if ($("#entry_name option[selected='selected']").length > 0) {
  //   // hiddenメール送信欄
  //   $("#entry_name_txt").val(entryNameSelectedTxt);
  //   // 確認画面欄
  //   $(".confirm_entry_name").text(entryNameSelectedTxt);
  // }
  // //================================
  // // selectボックスの選択ごとに要素を出現削除の実装
  // //================================
  // // valueの値 functions.phpで実装したターム(採用カテゴリ)のIDを出力している
  // // 文字列出力だったので文字列で定義
  // const entryElmOpen = "151"; //新卒採用
  // const entryElmClose = "152"; //中途採用
  // const entrySelectTitle = $(".js-form-select"); // セレクトボックスを取得する

  // // 対象のセレクトボックスがあったらリストを取得する
  // if (entrySelectTitle.length > 0) {
  //   const lists = $(".js-select-change"); //出現削除対象の要素
  //   // 関数定義
  //   const selected = (value, items) => {
  //     if (value === entryElmClose) {
  //       // 要素を非表示にする
  //       items.css("display", "none");
  //     } else {
  //       // 要素を表示にする
  //       items.css("display", "block");
  //     }
  //   };
  //   // イベントの関数
  //   function selectMove(event) {
  //     selected(event.target.value, lists);
  //   }

  //   // 初回読み込み時の実行
  //   selectMove({
  //     target: {
  //       // イベントを疑似発火のためセレクトボックスの初期値を使用
  //       value: entrySelectTitle.val(),
  //     },
  //   });

  //   // セレクトボックスの変更でイベント発火
  //   entrySelectTitle.on("change", function (event) {
  //     selectMove(event);
  //   });
  // }

  //================================
  // // ページ読み込み時のselectボックスの選択をhiddenしてるメール送信欄,確認画面欄に出力
  // //================================
  const entryNameSelect = $(".js-form-select");
  const entryNameSelectedVal = entryNameSelect.val();
  if (entryNameSelect.length > 0) {
    // 確認画面欄
    $(".confirm_entry_name").text(entryNameSelectedVal);
  }

  //================================
  // 希望職種ごとに要素を出現削除の実装,確認画面反映
  //================================
  // valueの値 functions.phpで実装したターム(採用カテゴリ)のIDを出力している
  // 文字列出力だったので文字列で定義
  const entryElmOpen = "151"; //新卒採用
  const entryElmClose = "152"; //中途採用
  const entrySelectTerm = $(".js-term"); // セレクトボックスを取得する
  const entrySelectName = $(".entry_name"); // セレクトボックスを取得する
  // 対象のセレクトボックスがあったらリストを取得する
  if (entrySelectTerm.length > 0) {
    const lists = $(".js-select-change"); //出現削除対象の要素
    const entrySelectVal = entrySelectTerm.val();
    // const entrySelectVal = entrySelectTerm.val();
    if (entrySelectVal === entryElmClose) {
      // 要素を非表示にする
      lists.css("display", "none");
    } else {
      // 要素を表示にする
      lists.css("display", "block");
    }
  }

  //================================
  // cf7の確認画面
  //================================
  // 入力内容取得用 変数
  let val;
  // id取得用 変数
  let id;
  // ラジオボタン値取得用 変数
  let radio;
  // チェックボックス値取得用 変数
  let check;
  // input要素のtype属性値取得用（ラジオボタンであるかどうか判別のため）
  let type;
  // ラジオボタン初期値の取得　以下の記述で全てのラジオボタンの初期値を取得
  // $("[type='radio']").each(function(index) {
  //   console.log($(this).val());
  //   console.log($(this).checked);
  //   // ラジオボタン値取得
  //   radio = $(this).val();
  //   // ラジオボタンの祖先要素からid名を取得
  //   id = $(this).parents("[id]").attr("id");
  //   // 取得したid名を確認用のclass名末尾に付与して、確認画面の値を指定
  //   $(".confirm_" + id).text(radio);
  // });

  // 入力画面時の入力input
  $(".input_area input,.input_area select,.input_area textarea").change(
    function () {
      let val = $(this).val(); //入力内容取得
      let type = $(this).attr("type"); //type属性の取得

      //type属性がラジオボタンだった場合の処理
      if (type == "radio") {
        let radio = $(this).val(); // ラジオボタン値取得
        let id = $(this).parents("[id]").attr("id"); // ラジオボタンの祖先要素からid名を取得
        $(".confirm_" + id).text(radio); // 取得したid名を確認用のclass名末尾に付与して、確認画面の値を指定
      } else if (type == "checkbox") {
        //type属性がチェックボックスだった場合の処理
        check = $(this).val(); // チェックボックス値取得
        id = $(this).parents("[id]").attr("id"); // チェックボタンの祖先要素からid名を取得
        let $confirmElement = $(".confirm_" + id); // 取得したid名を確認用のclass名末尾に付与する。

        if ($(this).is(":checked")) {
          // チェックボックスがチェックされた場合の処理  確認画面の値を追加
          if ($confirmElement.text().indexOf(check) === -1) {
            $confirmElement.append(check + " / ");
          }
        } else {
          // チェックボックスが外された場合の処理 確認画面の値を削除
          let text = $confirmElement.text().replace(check + " / ", "");
          $confirmElement.text(text);
        }
      } else if (type == "file") {
        // ファイルアップロードだった場合の処理
        id = $(this).attr("id");
        const file1ID = document.getElementById(id); //ファイル情報取得
        const file1 = file1ID.files[0]; //ファイル情報取得
        let file1Name = "選択されていません"; //ファイル名
        let fileVal = 0; //ファイルの選択有無
        //ファイルの選択無
        if (file1ID.files.length === 0) {
          fileVal = 0;
          file1Name = "選択されていません"; //選択されたファイル名を取得
        } else {
          //ファイルの選択有
          fileVal = 1;
          file1Name = file1.name; //選択されたファイル名を取得
        }
        // 取得したid名を確認用のclass名末尾に付与して、確認画面の値を指定
        $(".confirm_" + id).text(file1Name);
      } else if ($(this).is("select")) {
        id = $(this).attr("id");
        let obj = document.getElementById(id);
        let idx = obj.selectedIndex;
        let txt = obj.options[idx].text;
        // 取得したid名を確認用のclass名末尾に付与して、確認画面の値を指定
        $(".confirm_" + id).text(txt);
        if (id == "entry_name") {
          $("#entry_name_txt").val(txt);
        }
      } else {
        // 入力欄のid名を取得
        id = $(this).attr("id");
        // 取得したid名を確認用のclass名末尾に付与して、確認画面の値を指定
        $(".confirm_" + id).text(val);
      }
    }
  );

  //================================
  // cf7と自作のバリデーションチェックが全て通過したら確認ボタンを有効にする
  //================================
  // 必須項目チェック用定数
  const requiredItem =
    ".wpcf7-validates-as-required,.wpcf7-validates-as-email,.wpcf7-validates-as-tel"; // cf7のバリデート
  const validates = ".js-validates"; // バリデージョンかけているinputのクラス名
  const privacyBtnCheck = '[name="privacy-check"]'; //プライバシーポリシー同意チェック
  const radioGroups = $('input[type="radio"]');
  // const checkboxGroups = $('input[type="checkbox"]');
  const telGroups = $('input[type="tel"]');
  const confirmButton = $(".confirm_button"); //確認画面ボタン
  let allTelNumbersValid = true; // 電話番号バリデーションに使用
  let allMailValid = true; //メールアドレス確認用のバリデーションに使用

  let allRadioGroupsChecked = checkRadioGroups(); //全てのラジオボタンフィールド

  // const allCheckboxGroupsChecked = checkCheckboxesInGroups();
  //********************
  // 全てのバリデートが通過したら確認ボタンを有効にする
  //********************
  function checValidatorFields() {
    const isPrivacyChecked = $(privacyBtnCheck).is(":checked");

    // CF7の必須項目に全て値が入ったらtureを返す
    const allRequiredFieldsFilled =
      $(requiredItem).filter(function () {
        return $(this).hasClass("wpcf7-not-valid");
      }).length === 0;

    // 自作バリデーションが全て通過して.js-not-valiが無くなったらtrueを返す
    const allValidatesFieldsValid =
      $(validates).filter(function () {
        return $(this).hasClass("js-not-valid"); // バリデージョンに引っかかっていると出すクラス名
      }).length === 0;

    // デバッグ用
    // console.log("プライポリシーチェック" + isPrivacyChecked);
    // console.log("必須事項" + allRequiredFieldsFilled);
    // console.log("自作バリデーション" + allValidatesFieldsValid);
    // console.log("ラジオボタン" + allRadioGroupsChecked);
    // console.log("電話番号" + allTelNumbersValid);

    if (
      allRequiredFieldsFilled &&
      allValidatesFieldsValid &&
      allRadioGroupsChecked &&
      allTelNumbersValid &&
      allMailValid &&
      isPrivacyChecked
      // allCheckboxGroupsChecked &&
    ) {
      // 全てのバリデートが通過したら確認ボタンを有効にする
      enableConfirmButton();
      debugValid = true;
    } else {
      // バリデートに引っかかったら確認ボタンを無効にしてエラー出力フィールドまで移動
      disableConfirmButton();
      cf7Error();
      debugValid = false;
    }
    // console.log("Required fields checked");
  }

  //********************
  // cf7の必須項目、自作バリデート、プライポリシー同意フィールドの入力が終わったらエラー確認
  //********************
  $(requiredItem + "," + validates + "," + privacyBtnCheck).on(
    "change",
    function () {
      // cf7のjsで実行されるエラー確認完了してから実行するため遅延設定
      setTimeout(checValidatorFields, 100);
    }
  );
  //********************
  // ラジオボタンがチェックされているか
  //********************
  if (radioGroups.length > 0) {
    radioGroups.on("change", function () {
      allRadioGroupsChecked = checkRadioGroups();
      checValidatorFields();
    });
  }
  //********************
  // ボタン要素を有効化する（押せる）
  //********************
  function enableConfirmButton() {
    // console.log("clear");// デバッグ用
    confirmButton.removeAttr("disabled").addClass("click-change");
  }

  //********************
  // ボタン要素を無効化する（押せない）
  //********************
  function disableConfirmButton() {
    confirmButton.attr("disabled", "").removeClass("click-change");
  }

  //********************
  // エラー時エラー項目の上に移動
  //********************
  let cf7ErrorRunning = false;
  function cf7Error() {
    if (!cf7ErrorRunning) {
      cf7ErrorRunning = true;
      const speed = 300;

      // cf7のjsで実行されるエラー確認完了してから実行するため遅延設定
      setTimeout(() => {
        const firstCf7ErrorEl = ".wpcf7-not-valid:first";
        const firstErrorEl = ".js-not-valid:first";
        const logoHeight = "#js_hd_logo";
        // cf7のエラーがあったら最初の要素の位置を取得
        const firstCf7ErrorElTop = $(firstCf7ErrorEl).length
          ? $(firstCf7ErrorEl).offset().top
          : 0;
        // 自作のバリデートのエラーがあったら最初の要素の位置を取得
        const firstErrorElTop = $(firstErrorEl).length
          ? $(firstErrorEl).offset().top
          : 0;

        // cf7のエラー要素と自作のエラー要素のどちらがより上にあるか確認して上にある方に移動
        const scrollAmount =
          (firstCf7ErrorElTop && firstCf7ErrorElTop < firstErrorElTop) ||
          !firstErrorElTop
            ? firstCf7ErrorElTop
            : firstErrorElTop;

        if ($(firstCf7ErrorEl).length || $(firstErrorEl).length) {
          const logoTar = $(logoHeight).height();
          $("html, body").animate(
            { scrollTop: scrollAmount - logoTar },
            speed,
            "swing"
          );
        }
        cf7ErrorRunning = false;
      }, 200);
    }
  }
  //********************
  // 電話番号のバリデーションチェック
  //********************
  telGroups.each(function () {
    $(this).on("input", function () {
      const value = $(this).val();
      const pattern = /^[0-9]*$/; // 半角数字のみを許可するパターン
      const errorMsgPattern = "ハイフンや全角文字なしで入力してください";
      const errorMsgLength = "10桁または11桁で入力してください";

      // フィールドのクラスをリセット
      $(this).removeClass("js-not-valid");

      let valid = true;
      let $patternError = $(this)
        .nextAll(".custom-error.error-msg-pattern")
        .first();
      let $lengthError = $(this)
        .nextAll(".custom-error.length-error-msg")
        .first();

      if (value === "") {
        $patternError.remove();
        $lengthError.remove();
        $(this).removeClass("js-not-valid");
      } else {
        // パターンエラーチェック
        if (!pattern.test(value)) {
          if ($patternError.length === 0) {
            $(this).after(
              '<span class="custom-error error-msg-pattern">' +
                errorMsgPattern +
                "</span>"
            );
          }
          valid = false;
        } else {
          $patternError.remove();
        }

        // 長さエラーチェック
        if (value.length !== 10 && value.length !== 11) {
          if ($lengthError.length === 0) {
            $(this).after(
              '<span class="custom-error length-error-msg">' +
                errorMsgLength +
                "</span>"
            );
          }
          valid = false;
        } else {
          $lengthError.remove();
        }

        // 全体のバリデーション結果
        if (
          pattern.test(value) &&
          (value.length === 10 || value.length === 11)
        ) {
          valid = true;
        } else {
          $(this).addClass("js-not-valid");
        }
      }

      allTelNumbersValid = valid;
    });
    $(this).on("change", function () {
      // cf7のjsで実行されるエラー確認完了してから実行するため遅延設定
      setTimeout(checValidatorFields, 100);
    });
  });

  //********************
  //メールアドレス確認用のバリデーションチェック
  //********************
  const mailGroups = 'input[type = "email"]'; //メール入力欄
  // const mailGroups = $('input[type = "email"]'); //メール入力欄
  console.log($(mailGroups));
    
  let mailRequired = false; // メールの入力欄が必須かどうか
  // メール入力欄あったら
  if ($(mailGroups).length > 0) {
    // let mailInputAttr; // ID名
    // let mailInputlId; // メアドID
    // let $mailInput; // メアドの要素取得
    // let mailInputVal; //確認用のvalue

    // let mailConfAttr; // メアド確認用ID名
    // let mailConfId; // メアド確認用の要素取得
    // let $mailConf; //メアド確認用取得
    // let mailConfirmVal; //メアド確認用value

    $(mailGroups).on("input", function () {
      let id = $(this).attr("id");
      console.log('id:' + id);
      let $mailConf = $(this); //入力内容取得
      let valid = true;
      // メールアドレス（確認用）入力時
      let mailConfAttr;
      let $mailConfId;
      let mailConfirmVal;

      let mailInputAttr;
      let $mailInputId;
      let mailInputVal;

      let errorMsgMail = "メールアドレスが一致しません";
      if (id.includes("_conf")) {
        mailConfAttr = id;
        $mailConfId = $("#" + id); //type属性の取得
        mailConfirmVal = $(this).val(); //入力内容取得
        mailConfError = $mailConfId
          .nextAll(".custom-error.error-msg-mail-conf")
          .first();
        // "_conf"を除いたidを取得
        mailInputAttr = id.replace("_conf", "");
        $mailInputId = $("#" + mailInputAttr);
        mailInputVal = $mailInputId.val();
        mailInputError = $mailInputId
          .nextAll(".custom-error.error-msg-mail-conf")
          .first();

        if (
          (mailInputVal === "" && mailConfirmVal === "") ||
          mailInputVal === "" ||
          mailConfirmVal === ""
        ) {
          mailInputError.remove();
          $mailInputId.removeClass("js-not-valid");
          mailConfError.remove();
          $mailConfId.removeClass("js-not-valid");
          valid = true;
        } else if (mailConfirmVal !== mailInputVal) {
          $mailConfId.addClass("js-not-valid");
          valid = false;
          if (mailConfError.length === 0) {
            $mailConfId.after(
              '<span class="custom-error error-msg-mail-conf">' +
                errorMsgMail +
                "</span>"
            );
            $mailInputId.after(
              '<span class="custom-error error-msg-mail-conf">' +
                errorMsgMail +
                "</span>"
            );
          }
        } else {
          $mailConfId.removeClass("js-not-valid");
          mailConfError.remove();
          $mailInputId.removeClass("js-not-valid");
          mailInputError.remove();
          valid = true;
        }
        allMailValid = valid;
      } else {
        // メールアドレス欄入力時
        mailConfAttr = id + "_conf";
        $mailConfId = $("#" + mailConfAttr);
        mailConfirmVal = $mailConfId.val();
        mailConfError = $mailConfId
        .nextAll(".custom-error.error-msg-mail-conf")
        .first();

        mailInputAttr = id;
        $mailInputId = $("#" + mailInputAttr);
        mailInputVal = $mailInputId.val();
        mailInputError = $mailInputId
          .nextAll(".custom-error.error-msg-mail-conf")
          .first();

        if (
          (mailInputVal === "" && mailConfirmVal === "") ||
          mailInputVal === "" ||
          mailConfirmVal === ""
        ) {
          mailInputError.remove();
          $mailInputId.removeClass("js-not-valid");
          mailConfError.remove();
          $mailConfId.removeClass("js-not-valid");
          valid = true;
        } else if (mailInputVal !== mailConfirmVal) {
          $mailInputId.addClass("js-not-valid");
          valid = false;
          if (mailInputError.length === 0) {
            $mailConfId.after(
              '<span class="custom-error error-msg-mail-conf">' +
               errorMsgMail +
                "</span>"
            );
            $mailInputId.after(
              '<span class="custom-error error-msg-mail-conf">' +
               errorMsgMail +
                "</span>"
            );
          }
        } else {
          $mailConfId.removeClass("js-not-valid");
          mailConfError.remove();
          $mailInputId.removeClass("js-not-valid");
          mailInputError.remove();
          valid = true;
        }
        allMailValid = valid;
      }
      // console.log("mailInputVal：" + mailInputVal);
      // console.log("mailConfirmVal：" + mailConfirmVal);
      // cf7のjsで実行されるエラー確認完了してから実行するため遅延設定
      setTimeout(checValidatorFields, 100);
    });
  }
  //********************
  // ラジオボタンがチェックされているか
  //********************
  function checkRadioGroups() {
    const groups = {};
    // 必須項目のラジオボタンのみを対象にする

    radioGroups.each(function () {
      const groupName = $(this).attr("name");
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(this);
    });

    let allChecked = true;

    // ラジオボタンチェックが全てされているか
    for (const groupName in groups) {
      const checkedCount = groups[groupName].filter(
        (btn) => btn.checked
      ).length;
      // console.log("ラジオボタンチェックが全てされているか" + checkedCount);
      if (checkedCount !== 1) {
        allChecked = false;
        break;
      }
    }
    return allChecked;
  }

  //********************
  // チェックボタンがチェックされているか
  //********************
  // function checkCheckboxesInGroups() {
  //   const groups = {};
  //   const checkboxGroups = radioGroups.filter(requiredItem);
  //   checkboxGroups.each(function () {
  //     const groupName = $(this).attr("name");

  //     if (!groups[groupName]) {
  //       groups[groupName] = [];
  //     }
  //     groups[groupName].push(this);
  //   });

  //   let allChecked = true;

  //   for (const groupName in groups) {
  //     const checkboxesInGroup = groups[groupName];
  //     let checkedCount = 0;

  //     checkboxesInGroup.forEach((checkbox) => {
  //       if (checkbox.checked) {
  //         checkedCount++;
  //       }
  //     });
  //     // 1つでもチェックされていないグループがあれば、allCheckedをfalseにしてbreakでループを終了
  //     if (checkedCount === 0) {
  //       allChecked = false;
  //       break;
  //     }
  //   }
  //   return allChecked;
  // }

  const pageTtl = $(".page_title .text_ja");
  const pageSubTtl = $(".page_title .text_en");
  //********************
  //確認ボタンを押した際の処理
  //********************
  $(".confirm_button").click(function () {
    // cf7のjsで実行されるエラー表示を完了してから実行するため遅延設定
    setTimeout(confirmBtn, 200);
  });

  //********************
  // 入力画面を非表示・確認画面を表示
  //********************
  function confirmBtn() {
    if (debugValid) {
      pageTtl.text("入力内容確認");
      pageSubTtl.text("CONFIRMATION OF INPUT CONTENTS");
      $(".input_area").hide();
      // $(".confirm_area").show();
      $(".confirm_area").fadeIn(200);
      $(window).scrollTop($("#wrapper").position().top);
    }
  }

  //********************
  // //戻るボタンを押した際の処理　入力画面を表示・確認画面を非表示
  //********************
  $(".back_button").click(function () {
    pageTtl.text("お問い合わせ");
    pageSubTtl.text("CONTACT");
    $(".input_area").show();
    $(".confirm_area").hide();
    $(window).scrollTop($("#wrapper").position().top);
  });

  //********************
  // 送信ボタンを押した際に送信完了までローディング表示・確認画面非表示
  //********************
  $(document).on("submit", ".wpcf7-form", function () {
    pageTtl.text("送信中");
    pageSubTtl.text("SENDING CONTENTS");
    $(".confirm_area").hide();
    // $(".loading_area").show();
    $(".loading_area").fadeIn(200);

    $(window).scrollTop($("#wrapper").position().top);
  });

  //********************
  //CF7のDOMイベント
  // Ajaxのフォーム送信、メールの送信も行われた後に
  // サンクス（完了）画面を表示・ローディング画面を非表示
  //********************
  $(document).on("wpcf7mailsent", function (event) {
    pageTtl.text("送信完了");
    pageSubTtl.text("TRANSMISSION COMPLETE");
    $(".loading_area").hide();
    $(".thanks_area").fadeIn(800);
    $(window).scrollTop($("#wrapper").position().top);
  });
});

//********************
// YubinBangoのライブラリのインスタンスを元に住所を確認画面の住所に出力
//********************
document.addEventListener("DOMContentLoaded", function () {
  var addressInput = document.getElementById("your-address");
  var post1Input = document.getElementById("your-post1");
  var post2Input = document.getElementById("your-post2");

  // #your-addressの値が変更された際に、.confirm_your-addressを更新
  if (addressInput) {
    addressInput.addEventListener("input", function () {
      var confirmAddressElements = document.querySelectorAll(
        ".confirm_your-address"
      );
      confirmAddressElements.forEach(function (element) {
        element.innerHTML = addressInput.value;
      });
    });

    // 郵便番号入力フィールドのイベントリスナー
    var updateConfirmAddress = function () {
      var postalCode = post1Input.value + post2Input.value;
      if (postalCode.length === 7) {
        new YubinBango.Core(postalCode, function (address) {
          if (address.region) {
            // YubinBangoが住所を#your-addressに出力するのを待つ
            setTimeout(function () {
              var fullAddress = addressInput.value;
              var confirmAddressElements = document.querySelectorAll(
                ".confirm_your-address"
              );
              confirmAddressElements.forEach(function (element) {
                element.innerHTML = fullAddress;
              });
            }, 200); // 適切な遅延を設定
          }
        });
      }
    };

    post1Input.addEventListener("blur", updateConfirmAddress);
    post2Input.addEventListener("blur", updateConfirmAddress);
  }
});
